import { z } from 'zod';

const HHMM = /^([01]\d|2[0-3]):[0-5]\d$/;

export const MeetingTemplateDto = z.object({
  id: z.uuid(),
  slug: z.string(),
  emoji: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  defaultTime: z.string().nullable(),
  defaultDurationMinutes: z.number().int().nullable(),
});
export type MeetingTemplateDto = z.infer<typeof MeetingTemplateDto>;

export const AdminMeetingTemplateDto = MeetingTemplateDto.extend({
  sortOrder: z.number().int(),
  isActive: z.boolean(),
  allCities: z.boolean(),
  cityIds: z.array(z.uuid()),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});
export type AdminMeetingTemplateDto = z.infer<typeof AdminMeetingTemplateDto>;

// Base field validators без .default() — общие для create и update. Дефолты
// живут только на create-инпуте: на partial-update они бы «воскрешали» значения
// (например, cityIds → []), молча стирая привязки при PATCH без этого поля.
const baseShape = {
  slug: z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-z][a-z0-9-]*$/, 'lowercase, digits, dashes'),
  emoji: z.string().min(1).max(8),
  title: z.string().trim().min(1).max(120),
  description: z.string().max(2000).nullish(),
  defaultTime: z.string().regex(HHMM, 'HH:MM').nullish(),
  defaultDurationMinutes: z.number().int().min(5).max(1440).nullish(),
  sortOrder: z.number().int().min(0).max(10_000),
  isActive: z.boolean(),
  allCities: z.boolean(),
  cityIds: z.array(z.uuid()).max(500),
} as const;

export const MeetingTemplateCreateInput = z.object({
  ...baseShape,
  sortOrder: baseShape.sortOrder.default(0),
  isActive: baseShape.isActive.default(true),
  allCities: baseShape.allCities.default(false),
  cityIds: baseShape.cityIds.default([]),
});
export type MeetingTemplateCreateInput = z.infer<typeof MeetingTemplateCreateInput>;

// Partial без дефолтов: опущенное поле остаётся undefined, и сервис его не трогает.
export const MeetingTemplateUpdateInput = z.object(baseShape).partial();
export type MeetingTemplateUpdateInput = z.infer<typeof MeetingTemplateUpdateInput>;
